module.exports = __webpack_public_path__ + "static/media/pintura.dc43bbaf.svg";